var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { styled } from "styled-components";
import { Button, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Input, Label, Spinner, } from "@fluentui/react-components";
import { AudiencesService } from "../AudiencesService";
import { Picker, IdentityType } from "../components/Picker/Picker";
const StyledDialogContent = styled(DialogContent).withConfig({ displayName: "StyledDialogContent", componentId: "-1jkt8wx" }) `
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 600px;

  &.shadow {
    box-shadow: inset 0px -8px 7px -8px rgba(0, 0, 0, 0.14);
  }
`;
const StyledLabel = styled(Label).withConfig({ displayName: "StyledLabel", componentId: "-1qb7yes" }) `
  font-size: 14px !important;
  margin-bottom: 4px;
`;
const ModalWrapper = styled.div.withConfig({ displayName: "ModalWrapper", componentId: "-17svju2" }) `
  ${(p) => (p.showList ? "display:none;" : "")}
`;
const SectionTitle = styled.span.withConfig({ displayName: "SectionTitle", componentId: "-1d1bpr2" }) `
  display: inline-block;
  font-weight: 700;
  margin-bottom: 16px;
  margin-top: 8px;
`;
const MarginBottomInput = styled(Input).withConfig({ displayName: "MarginBottomInput", componentId: "-qbih69" }) `
  margin-bottom: 16px;
`;
const PickerWrapper = styled.div.withConfig({ displayName: "PickerWrapper", componentId: "-cpvonb" }) `
  margin-left: 3px;
`;
const StyledDialogActions = styled(DialogActions).withConfig({ displayName: "StyledDialogActions", componentId: "-15y1y3r" }) `
  padding-top: 24px;
`;
const StyledDialogTitle = styled(DialogTitle).withConfig({ displayName: "StyledDialogTitle", componentId: "-82shgf" }) `
  padding-bottom: 20px;
`;
const EditAudienceModal = ({ audience: audience, onClose, onSave, }) => {
    var _a, _b;
    const { CreateUpdateAudienceRule, getEntity } = AudiencesService();
    const [audienceName, setAudienceName] = useState((audience === null || audience === void 0 ? void 0 : audience.audienceName) || "");
    const [audienceDescription, setAudienceDescription] = useState((audience === null || audience === void 0 ? void 0 : audience.description) || "");
    const [isRenderingUsers, setIsRenderingUsers] = useState(true);
    const [isRenderingGroups, setIsRenderingGroups] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [isSaving, setIsSaving] = React.useState(false);
    const [isFormInvalide, setIsFormInvalide] = React.useState(true);
    const dialogContentRef = React.useRef(null);
    const [isNewAudience, setIsNewAudience] = useState(!audience);
    // INFO: Load selected users and groups is not required here, if entity id is provided in PickerUser can getEntity
    useEffect(() => {
        var _a, _b, _c, _d;
        if (((_a = audience === null || audience === void 0 ? void 0 : audience.users) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const users = [];
            (_b = audience === null || audience === void 0 ? void 0 : audience.users) === null || _b === void 0 ? void 0 : _b.forEach((entity) => {
                const user = {
                    id: entity.objectId,
                    type: IdentityType.User,
                };
                users.push(user);
            });
            setSelectedUsers(users);
        }
        else {
            setIsRenderingUsers(false);
        }
        if (((_c = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            const groups = [];
            (_d = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _d === void 0 ? void 0 : _d.forEach((entity) => {
                const group = {
                    id: entity.objectId,
                    type: IdentityType.Group,
                };
                groups.push(group);
            });
            setSelectedGroups(groups);
        }
        else {
            setIsRenderingGroups(false);
        }
    }, [audience]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        // INFO: show the spinner when the users and groups are rendereing
        if (((_a = audience === null || audience === void 0 ? void 0 : audience.users) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            if (isRenderingUsers && isRenderingGroups && audience) {
                setIsLoading(true);
            }
            else {
                setIsLoading(false);
            }
        }
        else if (((_c = audience === null || audience === void 0 ? void 0 : audience.users) === null || _c === void 0 ? void 0 : _c.length) > 0 && ((_d = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            if (isRenderingUsers && audience) {
                setIsLoading(true);
            }
            else {
                setIsLoading(false);
            }
        }
        else if (((_e = audience === null || audience === void 0 ? void 0 : audience.users) === null || _e === void 0 ? void 0 : _e.length) === 0 && ((_f = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _f === void 0 ? void 0 : _f.length) > 0) {
            if (isRenderingGroups && audience) {
                setIsLoading(true);
            }
            else {
                setIsLoading(false);
            }
        }
        else {
            setIsLoading(false);
        }
    }, [isRenderingUsers, isRenderingGroups, isLoading]);
    const handleScroll = () => {
        const element = dialogContentRef.current;
        if (element.scrollHeight > element.clientHeight) {
            element.classList.add("shadow");
        }
        else {
            element.classList.remove("shadow");
        }
    };
    function deleteUser(user) {
        const updated = selectedUsers.filter((u) => {
            return u.id !== user.id;
        });
        setSelectedUsers(updated);
    }
    function deleteGroup(user) {
        const updated = selectedGroups.filter((u) => {
            return u.id !== user.id;
        });
        setSelectedGroups(updated);
    }
    function addUsers(users) {
        setSelectedUsers(users);
    }
    function addGroups(users) {
        setSelectedGroups(users);
    }
    const handleAudienceSave = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!audienceName) {
            setIsFormInvalide(false);
            return;
        }
        setIsSaving(true);
        try {
            const updateUsers = [];
            const updateGroups = [];
            selectedUsers.forEach((entity) => {
                const pushEntity = {
                    objectId: entity.id,
                };
                updateUsers.push(pushEntity);
            });
            selectedGroups.forEach((entity) => {
                const pushEntity = {
                    objectId: entity.id,
                };
                updateGroups.push(pushEntity);
            });
            const newAudienceCollectionItem = {
                audienceId: audience === null || audience === void 0 ? void 0 : audience.audienceId,
                audienceName: audienceName,
                description: audienceDescription,
                users: updateUsers,
                groups: updateGroups,
            };
            const updated = yield CreateUpdateAudienceRule(newAudienceCollectionItem);
            yield onSave(updated, isNewAudience);
        }
        catch (e) {
            console.error(e);
            setIsSaving(false);
        }
        setIsSaving(false);
        onClose();
    });
    useEffect(() => {
        if (audienceName !== "" && audienceName !== undefined) {
            setIsFormInvalide(false);
        }
        else {
            setIsFormInvalide(true);
        }
    }, [audienceName]);
    return (_jsxs(DialogSurface, { children: [isLoading && _jsx(Spinner, { size: "large", label: "Loading..." }), _jsx(ModalWrapper, Object.assign({ showList: isLoading }, { children: _jsxs(DialogBody, { children: [_jsxs(StyledDialogTitle, { children: [!!audience ? "Edit" : "Create new", " audience"] }), _jsxs(StyledDialogContent, Object.assign({ onScroll: handleScroll, ref: dialogContentRef }, { children: [_jsx(StyledLabel, Object.assign({ htmlFor: "edit-audience-name", required: true }, { children: "Name" })), _jsx(MarginBottomInput, { id: "edit-audience-name", placeholder: "Define a name", size: "medium", value: audienceName, onChange: (e) => setAudienceName(e.target.value) }), _jsx(StyledLabel, Object.assign({ htmlFor: "edit-audience-description" }, { children: "Description (optional)" })), _jsx(MarginBottomInput, { id: "edit-audience-description", placeholder: "Insert description", size: "medium", value: audienceDescription, onChange: (e) => setAudienceDescription(e.target.value) }), _jsx(SectionTitle, { children: "Source" }), _jsx(PickerWrapper, { children: _jsx(Picker, { deleteUser: deleteGroup, selectedUsers: selectedGroups, setSelectedUsers: addGroups, identityType: 1, isRenderingEntities: (rendering) => setIsRenderingGroups(rendering), isPendingUsers: ((_a = audience === null || audience === void 0 ? void 0 : audience.groups) === null || _a === void 0 ? void 0 : _a.length) === 0 ? false : true }) }), _jsx(PickerWrapper, { children: _jsx(Picker, { deleteUser: deleteUser, selectedUsers: selectedUsers, setSelectedUsers: addUsers, identityType: 0, isRenderingEntities: (rendering) => setIsRenderingUsers(rendering), isPendingUsers: ((_b = audience === null || audience === void 0 ? void 0 : audience.users) === null || _b === void 0 ? void 0 : _b.length) === 0 ? false : true }) })] })), _jsx(StyledDialogActions, { children: isSaving ? (_jsx(Spinner, { size: "small", label: "Saving..." })) : (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ appearance: "secondary", onClick: onClose }, { children: "Cancel" })), _jsx(Button, Object.assign({ appearance: "primary", onClick: handleAudienceSave, disabled: isFormInvalide || isLoading }, { children: !!audience ? "Save" : "Create" }))] })) })] }) }))] }));
};
export default EditAudienceModal;
